/** Duration of the exit/dismiss animation in milliseconds. */
export const DURATION_EXIT = 1000;

/** Duration of the enter/appear animation in milliseconds. */
export const DURATION_ENTER = 500;

/** Default maximum number of toasts visible simultaneously before the oldest is auto-dismissed. */
export const MAX_NOTIFICATION = 3;

/** Vertical gap between stacked notification items in pixels. */
export const INDENT_BETWEEN_ITEM = 10;

/** Default time in milliseconds before a notification auto-dismisses itself. */
export const DEFAULT_AUTOHIDE_TIMEOUT = 3000;

/**
 * Horizontal screen edge where the notification stack anchors.
 * Pass one of these values as `anchorOrigin.horizontal`.
 */
export const HorizontalPositionElement = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
};

/**
 * Vertical screen edge where the notification stack anchors.
 * Pass one of these values as `anchorOrigin.vertical`.
 */
export const VerticalPositionElement = {
    TOP: 'TOP',
    BOTTOM: 'BOTTOM',
};

/**
 * Entrance/exit animation style for notifications.
 * - `SLIDE` — toasts slide in from the anchor edge (default).
 * - `FADE` — toasts fade in and out without movement.
 */
export const Animation = {
    SLIDE: 'SLIDE',
    FADE: 'FADE',
};

/**
 * Visual severity level of a notification. Controls icon and color.
 * - `DEFAULT` — neutral informational message (e.g. "Copied to clipboard").
 * - `ERROR` — destructive action failed or validation error.
 * - `SUCCESS` — operation completed successfully.
 * - `WARNING` — non-critical issue requiring user attention.
 */
export const Status = {
    DEFAULT: 'DEFAULT',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
};
